import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  Tooltip,
  TableBody,
  TableCell,
  Box,
  Typography,
  styled,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
  Checkbox,
  FormControlLabel,
  useTheme,
} from '@mui/material';
import  InfoOutlineIcon  from '@mui/icons-material/InfoOutlined';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  Search as SearchIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Navigate, useNavigate } from 'react-router-dom';

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SalaryHead = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 20, 30];
  
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');

const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddSalaryHeadModal, setShowAddSalaryHeadModal] = useState(false);
  const [showEditSalaryHeadModal, setShowEditSalaryHeadModal] = useState(false);
  const [selectedSalaryHead, setSelectedSalaryHead] = useState({
    salaryHeadId: null,
    salaryHead: '',
    calculatedBy: '',
    value: '',
    formula: '',
    salaryHeadType: '',
    processSequence: '',
    allowManualOverride: false
  });
  const [salaryHeadName, setSalaryHeadName] = useState('');
  const [calculatedBy, setCalculatedBy] = useState('');
  const [value, setValue] = useState('');
  const [formula, setFormula] = useState('');
  const [salaryHeadType, setSalaryHeadType] = useState('');
  const [processSequence, setProcessSequence] = useState('');
  const [allowManualOverride, setAllowManualOverride] = useState(false);

  // State for salary head data (previously static)
  const [salaryHeadData, setSalaryHeadData] = useState([
    { salaryHeadId: 1, salaryHead: 'Basic', calculatedBy: 'System', value: '1000', formula: 'Basic * 0.5', salaryHeadType: 'Earnings', processSequence: 1 },
    { salaryHeadId: 2, salaryHead: 'HRA', calculatedBy: 'User', value: '500', formula: 'Basic * 0.2', salaryHeadType: 'Earnings', processSequence: 2 },
    { salaryHeadId: 3, salaryHead: 'Bonus', calculatedBy: 'System', value: '200', formula: 'Basic * 0.1', salaryHeadType: 'Earnings', processSequence: 3 },
    { salaryHeadId: 4, salaryHead: 'Tax', calculatedBy: 'System', value: '100', formula: 'Basic * 0.05', salaryHeadType: 'Deductions', processSequence: 4 },
    { salaryHeadId: 5, salaryHead: 'PF', calculatedBy: 'User', value: '300', formula: 'Basic * 0.15', salaryHeadType: 'Deductions', processSequence: 5 },
    { salaryHeadId: 6, salaryHead: 'Insurance', calculatedBy: 'System', value: '200', formula: 'Basic * 0.1', salaryHeadType: 'Deductions', processSequence: 6 },
  ]);
  const navigate = useNavigate()
  // Static data for dropdowns
  const salaryHeadTypes = [
    { id: 1, name: 'Earnings' },
    { id: 2, name: 'Deductions' },
  ];

  const valueByOptions = [
    { id: 1, name: 'System' },
    { id: 2, name: 'User' },
  ];

  const handleEdit = (salaryHead) => {
    setSelectedSalaryHead(salaryHead);
    setSalaryHeadName(salaryHead.salaryHead);
    setCalculatedBy(salaryHead.calculatedBy);
    setValue(salaryHead.value);
    setFormula(salaryHead.formula);
    setSalaryHeadType(salaryHead.salaryHeadType);
    setProcessSequence(salaryHead.processSequence);
    setAllowManualOverride(false); // Assuming no data for this, default false
    setShowEditSalaryHeadModal(true);
  };

  const handleDelete = (salaryHead) => {
    setSelectedSalaryHead(salaryHead);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    setSalaryHeadData(salaryHeadData.filter((item) => item.salaryHeadId !== selectedSalaryHead.salaryHeadId));
    setSnackbarMessage('Salary Head Deleted Successfully');
    setOpenSnackbar(true);
    setShowDeleteModal(false);
    setSelectedSalaryHead({ salaryHeadId: null, salaryHead: '', calculatedBy: '', value: '', formula: '', salaryHeadType: '', processSequence: '' });
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedSalaryHead({ salaryHeadId: null, salaryHead: '', calculatedBy: '', value: '', formula: '', salaryHeadType: '', processSequence: '' });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = Number(event.target.value);
    setRowsPerPage(newRowsPerPage);
    setPage(1);
  };

  const handleAddSalaryHead = () => {
    setSalaryHeadName('');
    setCalculatedBy('');
    setValue('');
    setFormula('');
    setSalaryHeadType('');
    setProcessSequence('');
    setAllowManualOverride(false);
    setShowAddSalaryHeadModal(true);
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (salaryHeadType && salaryHeadName && processSequence && value && calculatedBy && formula) {
      setSnackbarMessage('Salary Head Added Successfully');
      setOpenSnackbar(true);
      setShowAddSalaryHeadModal(false);
      handleReset();
    } else {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
    }
  };

  const handleUpdate = () => {
    if (salaryHeadType && salaryHeadName && processSequence && value && calculatedBy && formula) {
      setSnackbarMessage('Salary Head Updated Successfully');
      setOpenSnackbar(true);
      setShowEditSalaryHeadModal(false);
      handleReset();
    } else {
     setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
    }
  };

  const handleReset = () => {
    setSalaryHeadName('');
    setCalculatedBy('');
    setValue('');
    setFormula('');
    setSalaryHeadType('');
    setProcessSequence('');
    setAllowManualOverride(false);
  };

  const handleCancel = () => {
    setShowEditSalaryHeadModal(false);
    handleReset();
  };

  const filteredData = salaryHeadData.filter((salaryHead) =>
    salaryHead.salaryHead.toLowerCase().includes(searchTerm.toLowerCase()) ||
    salaryHead.calculatedBy.toLowerCase().includes(searchTerm.toLowerCase()) ||
    salaryHead.salaryHeadType.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container maxWidth={false} sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:'space-between',

          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:2}}>
      <TextField
                                 variant="outlined"
                                 placeholder="Search..."
                                 value={searchTerm}
                                 onChange={(e) => setSearchTerm(e.target.value)}
                                 InputProps={{
                                   startAdornment: (
                                     <InputAdornment position="start">
                                       <SearchIcon
                                         sx={{
                                           color: theme.palette.primary.main,
                                           marginLeft: 1.5,
                                           fontSize: 24,
                                         }}
                                       />
                                     </InputAdornment>
                                   ),
                                   endAdornment: searchTerm && (
                                     <InputAdornment position="end">
                                       <IconButton
                                         size="small"
                                         onClick={() => setSearchTerm('')}
                                         sx={{
                                           color: "grey",
                                           marginRight: 1,
                                         }}
                                       >
                                         <CloseIcon fontSize="small" />
                                       </IconButton>
                                     </InputAdornment>
                                   ),
                                   sx: {
                                     borderRadius: '30px',
                                     backgroundColor: theme.palette.mode === 'dark'
                                       ? 'rgba(255, 255, 255, 0.15)'
                                       : 'rgba(255, 255, 255, 1)',
                                     boxShadow: theme.palette.mode === 'dark'
                                       ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                       : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                     '& .MuiOutlinedInput-notchedOutline': {
                                       border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                     },
                                     '&:hover': {
                                       backgroundColor: theme.palette.mode === 'dark'
                                         ? 'rgba(255, 255, 255, 0.2)'
                                         : 'rgba(240, 240, 240, 1)',
                                       boxShadow: theme.palette.mode === 'dark'
                                         ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                         : '0 2px 12px rgba(0, 0, 0, 0.15)',
                                     },
                                     '&.Mui-focused': {
                                       backgroundColor: theme.palette.mode === 'dark'
                                         ? 'rgba(255, 255, 255, 0.25)'
                                         : 'rgba(255, 255, 255, 1)',
                                       boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                       '& .MuiOutlinedInput-notchedOutline': {
                                         border: `2px solid ${theme.palette.primary.main}`,
                                       },
                                     },
                                     paddingLeft: 1.5,
                                     height: '50px',
                                     transition: 'all 0.3s ease',
                                   },
                                 }}
                                 sx={{
                                   width: 350,
                                   maxWidth: '100%',
                                   '& .MuiInputBase-input': {
                                     padding: '10px 14px',
                                     color: theme.palette.text.primary,
                                     fontWeight: 500,
                                   },
                                 }}
                               />
        <Button
          variant="contained"
          onClick={() => { navigate('/add-salary-head') }}
          sx={{
            ml: 2,
            width: "100px",
            borderRadius: '10px',
            height: "50px",
            padding: "10px 0",
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
          }}
          startIcon={<AddIcon />}
        >
          ADD
        </Button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={() => setShowUserGuideModal(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              minWidth: 0, // Remove MUI's default padding
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      </Box>
      <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 70 }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150 }}>Salary Head</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150 }}>Calculated By</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150 }}>Value</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150 }}>Formula</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150 }}>Salary Head Type</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 150 }}>Process Sequence</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem', minWidth: 120 }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((salaryHead, index) => (
                    <TableRow
                      key={salaryHead.salaryHeadId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{salaryHead.salaryHead}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{salaryHead.calculatedBy}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{salaryHead.value}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{salaryHead.formula}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{salaryHead.salaryHeadType}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{salaryHead.processSequence}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => navigate('/edit-salary-head/:salaryHeadId')}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(salaryHead)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                    backgroundColor: theme.palette.background.paper,
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}>
                    <TableCell colSpan={8} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                      No Record found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete {selectedSalaryHead.salaryHead}?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleConfirmDelete}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={showAddSalaryHeadModal}
        onClose={() => setShowAddSalaryHeadModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <CustomTableScrollbar
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 700,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Salary Head
            </Typography>
            <IconButton
              onClick={() => setShowAddSalaryHeadModal(false)}
              sx={{ color: '#fff' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px', overflowY: 'auto', flexGrow: 1 }}>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel
                htmlFor="salary-head-type"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                }}
              >
                Salary Head Type
              </InputLabel>
              <Select
                id="salary-head-type"
                value={salaryHeadType}
                label="Salary Head Type"
                onChange={(e) => setSalaryHeadType(e.target.value)}
              >
                {salaryHeadTypes.map((type) => (
                  <MenuItem key={type.id} value={type.name}>
                    {type.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Salary Head Name"
              variant="outlined"
              fullWidth
              value={salaryHeadName}
              onChange={(e) => setSalaryHeadName(e.target.value)}
              sx={{
                my: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Process Sequence"
              variant="outlined"
              fullWidth
              value={processSequence}
              onChange={(e) => setProcessSequence(e.target.value)}
              sx={{
                my: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Value"
              variant="outlined"
              fullWidth
              value={value}
              onChange={(e) => setValue(e.target.value)}
              sx={{
                my: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel
                htmlFor="select-value-by"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                }}
              >
                Select Value By
              </InputLabel>
              <Select
                id="select-value-by"
                value={calculatedBy}
                label="Select Value By"
                onChange={(e) => setCalculatedBy(e.target.value)}
              >
                {valueByOptions.map((option) => (
                  <MenuItem key={option.id} value={option.name}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Formula"
              variant="outlined"
              fullWidth
              value={formula}
              onChange={(e) => setFormula(e.target.value)}
              sx={{
                my: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={allowManualOverride}
                  onChange={(e) => setAllowManualOverride(e.target.checked)}
                  color="primary"
                />
              }
              label="Allow Manually Amount to be Overridden"
              sx={{ my: 2 }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={(!salaryHeadType || !salaryHeadName || !processSequence || !value || !calculatedBy || !formula) ? "Please fill all fields" : ""} arrow>
                <span>
                  <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.dark },
                    }}
                    disabled={!salaryHeadType || !salaryHeadName || !processSequence || !value || !calculatedBy || !formula}
                  >
                    SAVE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </CustomTableScrollbar>
      </Modal>
      <Modal
        open={showEditSalaryHeadModal}
        onClose={handleCancel}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <CustomTableScrollbar
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 700,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Salary Head
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px', overflowY: 'auto', flexGrow: 1 }}>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel
                htmlFor="salary-head-type"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                }}
              >
                Salary Head Type
              </InputLabel>
              <Select
                id="salary-head-type"
                value={salaryHeadType}
                label="Salary Head Type"
                onChange={(e) => setSalaryHeadType(e.target.value)}
              >
                {salaryHeadTypes.map((type) => (
                  <MenuItem key={type.id} value={type.name}>
                    {type.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Salary Head Name"
              variant="outlined"
              fullWidth
              value={salaryHeadName}
              onChange={(e) => setSalaryHeadName(e.target.value)}
              sx={{
                my: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Process Sequence"
              variant="outlined"
              fullWidth
              value={processSequence}
              onChange={(e) => setProcessSequence(e.target.value)}
              sx={{
                my: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Value"
              variant="outlined"
              fullWidth
              value={value}
              onChange={(e) => setValue(e.target.value)}
              sx={{
                my: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel
                htmlFor="select-value-by"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': {
                    color: theme.palette.primary.main,
                  },
                }}
              >
                Select Value By
              </InputLabel>
              <Select
                id="select-value-by"
                value={calculatedBy}
                label="Select Value By"
                onChange={(e) => setCalculatedBy(e.target.value)}
              >
                {valueByOptions.map((option) => (
                  <MenuItem key={option.id} value={option.name}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Formula"
              variant="outlined"
              fullWidth
              value={formula}
              onChange={(e) => setFormula(e.target.value)}
              sx={{
                my: 2,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={allowManualOverride}
                  onChange={(e) => setAllowManualOverride(e.target.checked)}
                  color="primary"
                />
              }
              label="Allow Manually Amount to be Overridden"
              sx={{ my: 2 }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !salaryHeadType ||
                    !salaryHeadName ||
                    !processSequence ||
                    !value ||
                    !calculatedBy ||
                    !formula
                    ? 'Please fill all fields'
                    : ''
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    onClick={handleUpdate}
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.dark },
                    }}
                    disabled={
                      !salaryHeadType ||
                      !salaryHeadName ||
                      !processSequence ||
                      !value ||
                      !calculatedBy ||
                      !formula
                    }
                  >
                    UPDATE
                  </Button>
                </span>
              </Tooltip>
              <Button variant="contained" color="error" onClick={handleCancel}>
                CANCEL
              </Button>
            </Box>
          </Box>
        </CustomTableScrollbar>
      </Modal>
      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Salary Head Management - User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
        <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
  {/* Section 1: Add Salary Head */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
  >
    ➤ Follow these steps to add a new salary head:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Click the <strong>"ADD"</strong> button at the top to navigate to the Add Salary Head page (<strong>/add-salary-head</strong>).
    </li>
    <li>
      On the add page, select the <strong>Salary Head Type</strong> (Earnings or Deductions) from the dropdown.
    </li>
    <li>
      Enter the <strong>Salary Head Name</strong>, <strong>Process Sequence</strong> (numeric), <strong>Value</strong>, <strong>Formula</strong>, and select <strong>Calculated By</strong> (System or User).
    </li>
    <li>
      Optionally, enable <strong>Allow Manual Override</strong> if users are permitted to override calculated amounts.
    </li>
    <li>
      Before clicking <strong>"SAVE"</strong>, ensure all required fields are filled. The Save button remains disabled otherwise.
    </li>
    <li>
      Click <strong>"SAVE"</strong> to add the salary head. A success snackbar message will be displayed.
    </li>
    <li>
      To clear all entered values, click the <strong>"RESET"</strong> button.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: All fields except the checkbox are mandatory.
  </Typography>

  {/* Section 2: Edit Salary Head */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to update a salary head:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      In the Salary Head List table, click the <strong>Edit</strong> icon (pencil) in the Action column to navigate to the Edit page (<strong>/edit-salary-head/:id</strong>).
    </li>
    <li>
      Update the required fields as needed, such as <strong>Salary Head Type</strong>, <strong>Salary Head Name</strong>, <strong>Process Sequence</strong>, <strong>Value</strong>, <strong>Formula</strong>, <strong>Calculated By</strong>, and the <strong>Manual Override</strong> option.
    </li>
    <li>
      Ensure all mandatory fields are completed before clicking <strong>"UPDATE"</strong>.
    </li>
    <li>
      Click <strong>"UPDATE"</strong> to save the changes. A snackbar will confirm the successful update.
    </li>
    <li>
      Click <strong>"CANCEL"</strong> to discard changes and return to the list.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Updated values will be reflected in the list after returning to the Salary Head List.
  </Typography>

  {/* Section 3: Delete Salary Head */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to delete a salary head:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      In the Salary Head List table, click the <strong>Delete</strong> icon (trash) in the Action column.
    </li>
    <li>
      Confirm the deletion by clicking <strong>"Yes, Delete"</strong> in the confirmation modal.
    </li>
    <li>
      The salary head will be removed from the list, and a snackbar message will confirm the deletion.
    </li>
    <li>
      Click <strong>"Cancel"</strong> to abort the deletion process.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Deletion is permanent and cannot be undone. Please proceed with caution.
  </Typography>

  {/* Section 4: Search Salary Heads */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to search salary heads:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Enter text in the search bar located at the top-left of the table.
    </li>
    <li>
      The list is filtered by <strong>Salary Head Name</strong>, <strong>Calculated By</strong>, or <strong>Salary Head Type</strong>.
    </li>
    <li>
      The table and pagination update automatically based on the search results.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Clear the search input to display all records.
  </Typography>

  {/* Section 5: Pagination */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to navigate the list:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Use the pagination controls at the bottom of the table, including arrows, page numbers, or the rows-per-page dropdown (5, 10, 20, or 30).
    </li>
    <li>
      The current page information is displayed (for example, Page 1 of 2).
    </li>
    <li>
      If no records match the criteria, the message <strong>"No Record found"</strong> will be shown.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Pagination applies to both filtered and searched results.
  </Typography>

  {/* Bottom Close */}
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
    {/* Optional close button if required */}
  </Box>
</CustomTableScrollbar>

        </Box>
      </Modal>
    </Container>
  );
};

export default SalaryHead;